import PropTypes from 'prop-types';
import React, { Component } from 'react';

import defined from '~app/core/defined';

import GradientButton from './GradientButton';

class TabControl extends Component {

  state = {
    selectedIndex: 0,
  };

  componentWillMount() {
    const index = defined(this.props.initialIndex) ?
      Math.min(Math.max(this.props.initialIndex, 0), this.props.buttonDefs.length - 1) :
      0;

    this.setState({
      selectedIndex: index,
    });
  }

  render() {
    return (
      <div className="TabControl">
        {this.renderButtonDefs()}
      </div>
    );
  }

  renderButtonDefs() {
    // Convert the list of button defs to a list of GradientButtons with
    // a divider div between each pair of buttons.
    // I don't want to render the divider and the button in the same render
    // helper function because then I have to wrap those pairs in an enclosing
    // div to satisfy a JSX rule, and I don't want to do that.
    // This reduce outputs a flattened array of jsx elements.
    return this.props.buttonDefs.reduce((jsxElements, buttonDef) => {
      // Compute the button index.
      const index = Math.floor((jsxElements.length + 1) / 2);

      // Add a divider before every button, except the first.
      if (jsxElements.length > 0) {
        jsxElements.push(this.renderDivider(index));
      }

      // Finally, add the button.
      jsxElements.push(this.renderButtonDef(buttonDef, index));
      return jsxElements;
    },
    []);
  }

  renderButtonDef(buttonDef, index) {
    return (
      <GradientButton
        key={`TabControlButton_${buttonDef.title}`}
        title={buttonDef.title}
        isSelected={this.state.selectedIndex === index}
        onClick={this.wrapOnClick(buttonDef.onClick, index)}
      />
    );
  }

  renderDivider(index) {
    return (
      <div
        className="TabControl__verticalDivider"
        key={`tabControlDivider_${index}`}
      />
    );
  }

  wrapOnClick(onClick, index) {
    return () => {
      this.setState({
        selectedIndex: index,
      });

      onClick();
    };
  }
}

TabControl.propTypes = {
  initialIndex: PropTypes.number,
  buttonDefs: PropTypes.array.isRequired,
};

export default TabControl;



// WEBPACK FOOTER //
// ./src/components/TabControl.js